export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/warrantyBadge.399acb56.svg","height":120,"width":121,"blurWidth":0,"blurHeight":0};